import React, { useContext } from 'react';
import { CartContext } from '../App';

const Checkout = React.memo(() => {
  const { cart } = useContext(CartContext);
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  return (
    <div className="checkout-container" style={{ padding: '3rem 2rem', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', margin: '2rem auto', maxWidth: '900px' }}>
      <h2>Checkout</h2>
      <p className="checkout-total">Total: ${total.toFixed(2)}</p>
      <form className="checkout-form" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <input type="text" placeholder="Full Name" required />
        <input type="text" placeholder="Address" required />
        <input type="text" placeholder="Credit Card (4242 4242 4242 4242)" required />
        <div className="checkout-submit">
          <button type="submit">Pay Now</button>
        </div>
      </form>
      <p className="checkout-note">Note: This is a prototype; no real payment processing occurs.</p>
    </div>
  );
});

export default Checkout;